import { useEffect, useRef } from 'react'
import { useViewport } from './useViewport'

export const useSnapPositionOnViewportResize = () => {
  const viewport = useViewport()

  const shouldSnapPositionRef = useRef(false)
  const previousViewportRef = useRef({ width: viewport.width, height: viewport.height })

  useEffect(() => {
    const previousViewport = previousViewportRef.current
    if (previousViewport.width !== viewport.width || previousViewport.height !== viewport.height) {
      shouldSnapPositionRef.current = true
      previousViewportRef.current = { width: viewport.width, height: viewport.height }
    }
  }, [viewport.height, viewport.width])

  return shouldSnapPositionRef
}
